import { RunService } from '../../services/service';
import { Component, OnInit } from '@angular/core';
import { Questions } from '../../models/questions';

@Component({
  selector: 'app-question-text',
  templateUrl: './question-text.component.html',
  styleUrls: ['./question-text.component.scss']
})
export class QuestionTextComponent implements OnInit {
  questions: Array <Questions> = [];
  isNew: boolean;
  notNew: boolean;
  newRubricPrompt: boolean;
  constructor(private service: RunService) { }

  ngOnInit() {
    this.isNew = true;
    this.newRubricPrompt = true;
  }

  radioBtnClick(value: string) {
    if (value === 'new') {
      this.isNew = true;
      this.notNew = false;
    }
    else {
      this.notNew = true;
      this.isNew = false;
    }
  }



}
